import Splide from '@splidejs/splide'
import '@splidejs/splide/css'

const teamMembersCarousel = () => {
    const teams = document.querySelectorAll( '.wp-block-query.is-style-carousel' )
    if ( teams.length === 0 ) return

    const options = {
        perPage: 4,
        perMove: 1,
        pagination: false,
        breakpoints: {
            950: {
                perPage: 2
            }
        }
    }

    const setClasses = team => {
        team.parentNode.classList.add('splide')
        team.classList.add('splide__track')
        team.querySelector('.wp-block-post-template').classList.add('splide__list')
        team.querySelectorAll('.wp-block-post').forEach(post => post.classList.add('splide__slide'))
    }
      
    const initSwiper = (team,idx) => {
        team.parentNode.id = `splide-${idx}`;
        setClasses(team);
        new Splide( `#splide-${idx}`, options ).mount();

    }
    teams.forEach(initSwiper)
}

export default teamMembersCarousel;